import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { InvestmentType } from '@repo/position-types'
import { InvestmentFilters } from '@repo/shared-types'

const initialState: Partial<Record<InvestmentType, InvestmentFilters | null>> = {
  etfs: null,
  derivatives: null,
  epsv: null,
  fixedIncome: null,
  funds: null,
  pensionPlans: null,
  variableIncome: null,
  warrants: null,
}

export const {
  actions: positionInvestmentsFiltersActions,
  reducer: positionInvestmentsFiltersReducers,
} = createSlice({
  name: '@position/master/filters/investments',
  initialState,
  reducers: {
    clearFilter: (
      state,
      action: PayloadAction<{
        product: InvestmentType
      }>,
    ) => {
      state[action.payload.product] = null
    },
    reset: (_state) => initialState,
    setFilter: (
      state,
      action: PayloadAction<{
        product: InvestmentType
        filters: InvestmentFilters
      }>,
    ) => {
      const { filters, product } = action.payload
      state[product] = { search: filters.search }
    },
  },
})
